<template>
  <div class="content">
    <div class="p">How to troubleshoot a reversed CT.</div>

    <div class="p">
      Each CT must be
      <ul class="p">
        <li>Clipped in the correct orientation</li>
        <li>The correct polarity at the SolShare connector</li>
      </ul>
    </div>

    <div class="p">
      Connection to check:
      <ul class="p">
        <li v-for="(unit, i) in CTReversedUnits" :key="i">{{ unit }}</li>
      </ul>
    </div>

    <back-and-next
      next-text="Next - CT Installation"
      to="/commission/error/reversed-ct-au/2"
      data-tn="reversed-ct-au/1"
    >
    </back-and-next>
  </div>
</template>

<script>
import { CommissionErrorMixin } from "../../../../../mixins/commissionError";

export default {
  mixins: [CommissionErrorMixin],
};
</script>

<style scoped lang="less">
.content {
  .p {
    margin-top: 20px;
  }
}
</style>
